import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2SocioOtros } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

import { KeyEventUtil } from 'utils'

import * as SocioCrud from 'services/socio.service'

const TrabajadorFormGroup = ({ iError, iTouched, fIsSubmitting, iValue, values, setValues }) => {
  const onChangeSocioHandler = pickedMember => {
    SocioCrud.obtenerxIdAsInfoSlim(pickedMember.value).then(({ data }) => {
      values._idTrabajador = pickedMember.value
      values.codigoTrabajador = data.codigo
      values.documentoTrabajador = data.numeroDocumento
      values.nombreTrabajador = data.razonSocial
      values.tipoDocumentoTrabajador = data.tipoDocumento

      setValues(values)

      KeyEventUtil.leaveOnKeyEvent('select-partida')
    })
  }

  const onCreate = React.useCallback(
    (socioCreado, closeModal) => {
      values._idTrabajador = socioCreado._id
      values.codigoTrabajador = socioCreado.codigo
      values.documentoTrabajador = socioCreado.numeroDocumento
      values.nombreTrabajador = socioCreado.razonSocial
      values.tipoDocumentoTrabajador = socioCreado.tipoDocumento

      setValues(values)
      closeModal()
    },
    [values, setValues]
  )

  const clickClear = React.useCallback(() => {
    values._idTrabajador = ''
    values.codigoTrabajador = ''
    values.documentoTrabajador = ''
    values.nombreTrabajador = ''
    values.tipoDocumentoTrabajador = ''

    setValues(values)
    KeyEventUtil.leaveOnKeyEvent('select-sociootros')
  }, [setValues, values])

  return (
    <>
      <Form.Group>
        <Form.Label text='TRBJR' htmlFor='input-sociootros' md={3} alignRightAt='md' />
        <Col md={9}>
          {iValue ? (
            <ClearInputGroup
              id='input-sociootros'
              iValue={`${values.documentoTrabajador} - ${values.nombreTrabajador}`}
              clickClear={clickClear}
            />
          ) : (
            <>
              <Select2SocioOtros
                disabled={fIsSubmitting}
                id='select-sociootros'
                onChange={onChangeSocioHandler}
                showNewButton
                onCreate={onCreate}
              />
            </>
          )}
          {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(TrabajadorFormGroup)
